<script setup>
import CartProductItem from "~/components/molecules/CartProductItem.vue";
import {useCartStore} from "~/store/cartStore";
import {getNextCartQuantity} from "~/utils/cartQuantity.js";

const store = useCartStore();

function increaseQuantity(product) {
  const next = getNextCartQuantity(product, 1)
  const current = parseInt(product.quantity, 10)

  if (next === current) {
    return
  }

  store.updateItem(product.id, next)
}

function decreaseQuantity(product) {
  const next = getNextCartQuantity(product, -1)
  const current = parseInt(product.quantity, 10)

  if (next === current) {
    return
  }

  store.updateItem(product.id, next)
}
</script>

<template>
  <div class="products no-flex g-16 the-same-gap">
    <template v-for="product in store.content?.products">
      <CartProductItem
          :price="product.price"
          @click="$emit('click')"
          :isRestparti="product.attributes.lager_status === 'Restparti'"
          :link="'/shop/'+product.attributes.url"
          :is_sample="product.name.toLowerCase().includes('varuprov') || product.is_sample || product?.attributes?.sample"
          @remove="store.removeItem(product.id,product.is_sample)"
          @plus="increaseQuantity(product)"
          @minus="decreaseQuantity(product)"
          @update="store.updateItem(product.id,$event)"
          :image="product.attributes.image" :quantity="product.quantity"
          :product_type="product.attributes.group_category"
          :tile_bundle="Boolean(product.attributes.tile_bundle)"
          :total="product.sub_total" :unit_per_box="product.attributes.unit_qty"
          :min_volume_to_buy="product.min_volume_to_buy ?? product.attributes?.min_volume_to_buy ?? 1"
          :cart_multiplicity="product.attributes.cart_multiplicity ?? 1"
          :unit="product.attributes.unit" :name="product.name" :sku="product.attributes.sku"
          :supplier_id="product.attributes.supplier_id">
        <slot :product="product"/>
      </CartProductItem>
    </template>
  </div>
</template>

<style scoped lang="scss">

</style>
